import React from "react";
import { Dropdown } from "react-bootstrap";
import "../../assets/css/productshoting.css";

const ProductShortingcollection = () => {
  return (
    <Dropdown>
      <Dropdown.Toggle className="button-btn mr-1" style={{ color:"#6c6969 !important"}}>
        <i className="bi bi-sort-down-alt"></i> Sort
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item href="#newest">Newest First</Dropdown.Item>
        <Dropdown.Item href="#low-high">Price: Low to High</Dropdown.Item>
        <Dropdown.Item href="#high-low">Price: High to Low</Dropdown.Item>
        <Dropdown.Item href="#name-az">Name: A to Z</Dropdown.Item>
        <Dropdown.Item href="#name-za">Name: Z to A</Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ProductShortingcollection;